(() => {
  if (window.ihBoldMobileReview) return;
  window.ihBoldMobileReview = true;
  const phone = window.matchMedia('(max-width: 749px)');
  const states = new Map();
  let collectionObserver;
  let watchedCollection;
  let stickyObserver;
  let watchedBar;

  function disclosure(root, selector, key, label) {
    const target = root.querySelector(selector);
    if (!target || target.closest('[data-bold-disclosure]')) return;
    const details = document.createElement('details');
    details.className = 'bold-mobile-disclosure';
    details.dataset.boldDisclosure = key;
    details.open = states.get(key) || false;
    const summary = document.createElement('summary');
    summary.textContent = label;
    summary.dataset.ihFeature = 'product-buying-facts';
    summary.dataset.ihAction = 'mobile_details_toggle';
    summary.dataset.ihResource = 'bold-' + key;
    details.append(summary);
    target.before(details);
    details.append(target);
    details.addEventListener('toggle', () => {
      states.set(key, details.open);
      if (details.open) window.dispatchEvent(new Event('resize'));
    });
  }

  function arrange() {
    const root = document.querySelector('product-info');
    if (root?.querySelector('[data-collection-shopping]')?.dataset.currentHandle !== 'bold-black-and-gold-knurled-cabinet-pulls') return;
    if (!phone.matches) {
      root.removeAttribute('data-bold-mobile-review');
      root.removeAttribute('data-bold-coordination-active');
      collectionObserver?.disconnect();
      watchedCollection = null;
      root.querySelectorAll('[data-bold-disclosure]').forEach(details => {
        states.set(details.dataset.boldDisclosure, details.open);
        [...details.children].filter(el => el.tagName !== 'SUMMARY').forEach(el => details.before(el));
        details.remove();
      });
      return;
    }
    root.dataset.boldMobileReview = '';
    disclosure(root, '[data-finish-samples]', 'samples', 'Explore finish samples');
    disclosure(root, '[data-variant-model-mobile-anchor]', 'model', 'View in 3D & compare size');
    disclosure(root, '[data-product-documents]', 'documents', 'Product drawings & downloads');

    const collection = root.querySelector('[data-collection-shopping]');
    if (collection && watchedCollection !== collection) {
      collectionObserver?.disconnect();
      watchedCollection = collection;
      collectionObserver = new IntersectionObserver(entries => {
        root.toggleAttribute('data-bold-coordination-active', entries[0].isIntersecting);
        // Reuse the existing sticky-bar/chat-clearance synchronization.
        window.dispatchEvent(new Event('resize'));
      }, { rootMargin: '-80px 0px -100px 0px' });
      collectionObserver.observe(collection);
    }
    const bar = root.querySelector('[data-mobile-purchase-bar]');
    if (bar && watchedBar !== bar) {
      stickyObserver?.disconnect();
      watchedBar = bar;
      const label = bar.querySelector('[data-mobile-purchase-selection]');
      const updateLabel = () => {
        if (!phone.matches) return;
        const facts = [...root.querySelectorAll('[data-purchase-facts] > p[hidden]')];
        const size = facts.find(p => /^(Size|Length)\b[^:]*:/.test(p.textContent.trim()));
        const finish = facts.find(p => /^Finish\s*:/.test(p.textContent.trim()));
        const text = [size, finish].filter(Boolean).map(p => p.textContent.replace(/^[^:]+:\s*/, '').trim()).join(' · ');
        if (label && text && label.textContent !== text) label.textContent = text;
      };
      stickyObserver = new MutationObserver(updateLabel);
      stickyObserver.observe(bar, { childList: true, subtree: true });
      updateLabel();
    }
  }
  const schedule = () => window.requestAnimationFrame(arrange);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  document.addEventListener('product-info:loaded', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, schedule);
  }
  phone.addEventListener('change', arrange);
})();
